import SimpleTable from '@/components/common/tables/simpleTable';
import { OPTHistoryData } from '@/interfaces';
import { format, parseISO } from 'date-fns';
import * as React from 'react';

export const OptRequestDocument: React.FC<{
	isLoading: boolean;
	optHistory: OPTHistoryData[];
}> = ({ isLoading, optHistory }) => {
	return (
		<div>
			<SimpleTable<OPTHistoryData & { isActive: boolean; isEmptyRow: boolean }>
				hideRowActions
				classNameContainer="!rounded-t-2xl !rounded-b-2xl shadow-none !pr-0 max-h-[400px] overflow-y-auto"
				classNameHeader="grid grid-cols-[2fr,1fr,1fr,1fr] !bg-gray-15"
				classNameRows="grid grid-cols-[2fr,1fr,1fr,1fr] hover:!bg-transparent hover:!border-b-dark-10 hover:!border-t-dark-10 hover:!border-x-transparent !rounded-none"
				classNameHead="!opacity-100"
				isLoading={isLoading}
				columns={[
					{
						header: 'File Name',
						content: (instance) =>
							instance.isEmptyRow ? null : (
								<span className="text-xs text-black">
									{instance.document_name}
								</span>
							),
					},
					{
						header: 'Total Clients',
						content: (instance) =>
							instance.isEmptyRow ? null : (
								<span className="bg-grey-100 py-0.5 px-1.5 rounded-md text-xs">
									{instance.active_users} Clients
								</span>
							),
					},
					{
						header: 'sent',
						content: (instance) =>
							instance.isEmptyRow ? null : (
								<span className="text-xs">
									{format(parseISO(instance.created_at), 'MMM dd, yyyy')}
									<br />
									<span className="text-grey-40">
										{format(parseISO(instance.created_at), 'HH:mm a')}
									</span>
								</span>
							),
					},
				]}
				rows={
					optHistory && optHistory.length > 0
						? optHistory.map((item) => ({
								...item,
								isActive: false,
								isEmptyRow: false,
						  }))
						: [
								{
									id: '',
									case_id: '',
									document_name: '',
									document_url: '',
									active_users: 0,
									is_sent: false,
									created_at: '',
									isActive: false,
									isEmptyRow: true,
								},
						  ]
				}
				hasPagination={false}
			/>
		</div>
	);
};
